export enum PriceCategoryWidget {
    SELECT = "select",
    RADIO = "radio"
  }